import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useT } from "../hooks/useLang";

function LangToggle() {
  const [lang, setLang] = useState(localStorage.getItem("lang") || "fr");

  const toggle = () => {
    const next = lang === "fr" ? "en" : "fr";
    setLang(next);
    localStorage.setItem("lang", next);
    window.dispatchEvent(new CustomEvent("langChange", { detail: next }));
  };

  return (
    <button
      onClick={toggle}
      style={{
        display: "inline-flex",
        alignItems: "center",
        border: "2.5px solid var(--border)",
        borderRadius: 30,
        overflow: "hidden",
        boxShadow: "var(--shadow-sm)",
        cursor: "pointer",
        background: "transparent",
        padding: 0,
        height: 32,
      }}
      aria-label="Changer de langue"
    >
      {["fr", "en"].map((l) => (
        <span
          key={l}
          style={{
            padding: "0 11px",
            height: "100%",
            display: "flex",
            alignItems: "center",
            fontWeight: 700,
            fontSize: "0.75rem",
            letterSpacing: "0.05em",
            background: lang === l ? "#E0392B" : "var(--bg-card)",
            color: lang === l ? "#F5EAD3" : "var(--ink)",
            transition: "background 0.2s, color 0.2s",
            userSelect: "none",
          }}
        >
          {l.toUpperCase()}
        </span>
      ))}
    </button>
  );
}

export default function Header() {
  const t = useT();
  const [menuOpen, setMenuOpen] = useState(false);

  const role = localStorage.getItem("role");
  const token = localStorage.getItem("token");
  const username = localStorage.getItem("username");
  const isAdmin = !!token && role === "admin";

  const navLinks = [
  { to: "/", label: t("accueil") },
  { to: "/qui-sommes-nous", label: t("quiSommesNous") },
  { to: "/nos-services", label: t("nosServices") },
  { to: "/news", label: t("news") },
  { to: "/contact", label: t("contact") },
];

  return (
    <header className="fixed top-0 w-full z-50"
      style={{ backgroundColor: "var(--bg-card)", borderBottom: "3px solid var(--border)" }}>
      <div className="max-w-6xl mx-auto flex items-center justify-between px-6 h-16">

        <Link to="/" className="flex items-center gap-2">
          <img src="/images/Startinfive2.png" alt="Logo"
            style={{ width: 38, height: 38, objectFit: "contain", mixBlendMode: "multiply" }} />
          <span style={{
            fontFamily: "var(--font-display)",
            fontSize: "1.1rem",
            color: "var(--primary)",
            letterSpacing: "0.01em",
          }}>
            Starting Five
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:block">
          <ul className="flex items-center gap-1 text-sm">
            {navLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to}
                  style={{
                    color: "var(--ink)",
                    padding: "7px 12px",
                    borderRadius: 8,
                    display: "block",
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: "0.04em",
                    fontSize: "0.75rem",
                  }}
                  className="hover:bg-yellow-100 transition">
                  {l.label}
                </Link>
              </li>
            ))}

            {/* Visible uniquement si connecté en admin */}
            {isAdmin && (
              <>
                <li className="ml-2">
                  <Link to="/admin" className="brut-btn brut-btn-primary" style={{ padding: "7px 14px" }}>
                    ⚙️ Admin
                  </Link>
                </li>
                <li>
                  <Link to="/parametres" className="brut-btn brut-btn-white" style={{ padding: "7px 14px" }}>
                    {username}
                  </Link>
                </li>
              </>
            )}

            {/* Lien login complètement caché — accessible uniquement en tapant /login dans l'URL */}
            <li className="ml-3">
              <LangToggle />
            </li>
          </ul>
        </nav>

        {/* Mobile burger */}
        <button
          className="md:hidden flex flex-col justify-center items-center w-10 h-10 gap-1.5"
          style={{
            border: "3px solid var(--border)", borderRadius: 8,
            background: "var(--accent)", boxShadow: "var(--shadow-sm)",
          }}
          onClick={() => setMenuOpen(!menuOpen)}>
          <span className={`block w-5 h-0.5 bg-gray-900 transition-all ${menuOpen ? "rotate-45 translate-y-1.5" : ""}`} />
          <span className={`block w-5 h-0.5 bg-gray-900 transition-all ${menuOpen ? "opacity-0" : ""}`} />
          <span className={`block w-5 h-0.5 bg-gray-900 transition-all ${menuOpen ? "-rotate-45 -translate-y-1.5" : ""}`} />
        </button>
      </div>

      {/* Mobile drawer */}
      {menuOpen && (
        <div style={{ background: "var(--bg-card)", borderTop: "3px solid var(--border)" }}
          className="md:hidden px-6 py-4 space-y-1">
          {navLinks.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setMenuOpen(false)}
              className="block px-3 py-3 font-bold text-sm uppercase hover:bg-yellow-50 rounded-lg transition"
              style={{ color: "var(--ink)", letterSpacing: "0.05em" }}>
              {l.label}
            </Link>
          ))}
          {isAdmin && (
            <div style={{ borderTop: "2px dashed var(--border)", paddingTop: 12, marginTop: 8 }}>
              <Link to="/admin" onClick={() => setMenuOpen(false)}
                className="block px-3 py-3 font-bold text-sm hover:bg-yellow-50 rounded-lg"
                style={{ color: "var(--ink)" }}>⚙️ Admin</Link>
              <Link to="/parametres" onClick={() => setMenuOpen(false)}
                className="block px-3 py-3 font-bold text-sm hover:bg-yellow-50 rounded-lg"
                style={{ color: "var(--ink)" }}>👤 {username}</Link>
            </div>
          )}
          <div style={{ marginTop: 12 }}>
            <LangToggle />
          </div>
        </div>
      )}
    </header>
  );
}
